export default "__VITE_ASSET__Dmtz7JOQ__"